enum DigitalAssetRoutes {
  List = '/digitalassets',
  Edit = '/digitalassets/edit/:id',
  Add = '/digitalassets/add',
}

export default DigitalAssetRoutes
